import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import { SIGNOUT } from "./currentUser";

import api from "./api";
import apis from "./apis";
import charts from "./charts";
import chartsAdmin from "./chartsAdmin";
import config from "./config";
import confirmation from "./confirmation";
import currentUser from "./currentUser";
import enquiries from "./enquiries";
import favouriteNumbers from "./favouriteNumbers";
import flashes from "./flashes";
import hospital from "./hospital";
import hospitals from "./hospitals";
import inviteRequests from "./inviteRequests";
import invites from "./invites";
import modal from "./modal";
import chartsMixpanel from "./chartsMixpanel";
import number from "./number";
import numbers from "./numbers";
import exclusionNumber from "./exclusionNumber";
import exclusionList from "./exclusionList";
import numbersCopy from "./numbersCopy";
import numbersImport from "./numbersImport";
import passwordResets from "./passwordResets";
import pendingInvites from "./pendingInvites";
import sidebar from "./sidebar";
import user from "./user";
import users from "./users";
import whitelistedDomain from "./whitelistedDomain";
import whitelistedDomains from "./whitelistedDomains";
import whitelistedUsers from "./whitelistedUsers";
import workspaces from "./workspaces";
import workspaceRelatedIds from "./workspaceRelatedIds";
import revokeUser from "./revokeUser";
import email from "./email";
import emails from "./emails";
import adminOrganisations from "./organisation/admin/organisations";
import adminOrganisation from "./organisation/admin/organisation";
import organisation from "./organisation/organisation";
import userOrganisations from "./organisation/userOrganisations";

const appReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    api,
    apis,
    charts,
    chartsAdmin,
    config,
    confirmation,
    currentUser,
    enquiries,
    favouriteNumbers,
    flashes,
    hospital,
    hospitals,
    inviteRequests,
    invites,
    modal,
    chartsMixpanel,
    number,
    numbers,
    exclusionNumber,
    exclusionList,
    numbersCopy,
    numbersImport,
    passwordResets,
    pendingInvites,
    sidebar,
    user,
    users,
    whitelistedDomain,
    whitelistedDomains,
    whitelistedUsers,
    workspaces,
    workspaceRelatedIds,
    revokeUser,
    email,
    emails,
    org: organisation,
    userOrganisations,
    organisations: adminOrganisations,
    organisation: adminOrganisation,
  });

export default (history) => (state, action) => {
  if (action.type === SIGNOUT) {
    state = {
      api: state.api,
      apis: state.apis,
      config: state.config,
    };
  }

  return appReducer(history)(state, action);
};
